import { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import { IFlowSubscriber } from '../../../modules/epflow'
import { Locale } from '../../../modules/locale'
import MainModule from '../../../modules/main'

Locale.getInstance().registerKeySet('fr', 'create-event-add-contributors', {
  title: 'Ajoutez des contributeur·rice·s',
  description:
    'Vous pouvez ajouter des contributeur·rice·s déjà existant·e·s ou en créer de nouveaux.',
  errors: {
    general: 'Requis',
    generic: 'Veuillez corriger les erreurs ci-dessous',
  },
})

Locale.getInstance().registerKeySet('en', 'create-event-add-contributors', {
  title: 'Add contributors',
  description: 'You can add existing contributors or create new ones.',
  errors: {
    general: 'Required',
    generic: 'Please correct the errors below',
  },
})

export interface LvcCreateEventAddContributors {
  flowGroup: string
  flowStep: string
  errors: any
  contributors: any
}

export interface AddContributorsData {
  contributors: any
}

export class LvcCreateEventAddContributors
  extends MinzeElement
  implements MinzeElement, IFlowSubscriber
{
  showUserForm: boolean = true
  attrs: Attrs = [
    ['flow-step', ''],
    ['data-type', 'event'],
    ['flow-group', ''],
  ]

  reactive: Reactive = [
    ['contributors', [], false],
    [
      'errors',
      {
        general: false,
        generic: false,
      },
      false,
    ],
  ]

  handleContributorsChange(event: any) {
    this.contributors = event.detail.contributors

    // Get the FlowCore instance to save the data
    const flowCore = MainModule.getInstance().getFlowManager().getCore(this.flowGroup)

    if (flowCore) {
      flowCore.save()
    } else {
      console.warn('FlowCore instance not found, Saving aborted.')
    }
  }

  onReady() {
    const mainModule = MainModule.getInstance()
    mainModule?.getFlowManager()?.subscribe(this)
  }

  onDestroy() {
    MainModule?.getInstance()?.getFlowManager()?.unsubscribe(this)
  }

  public async deserialize(data?: unknown): Promise<void> {
    // We get the data from the flowCore and we set the values of the inputs
    const d = (data as AddContributorsData) ?? {}
    this.contributors = d.contributors ?? []
    this.rerender()
  }

  public async serialize(): Promise<unknown> {
    return {
      contributors: this.contributors,
    }
  }

  public async validate(): Promise<boolean> {
    for (const key in this.errors) {
      this.errors[key] = false
    }

    this.contributors.forEach((contributor: any) => {
      // if one of the fields is empty, return a general error
      if (
        !contributor.contributorName ||
        !contributor.contributorType ||
        !contributor.contributionType
      ) {
        this.errors.general = Locale.getKey('create-event-add-contributors.errors.general')
      }
    })

    let hasErrors = false
    for (const key in this.errors) {
      if (this.errors[key]) {
        hasErrors = true
      }
    }

    // if we have errors, go to the top of the page
    // and show generic error message
    if (hasErrors) {
      window.scrollTo(0, 0)
      this.errors.generic = Locale.getKey('create-event-add-contributors.errors.generic')
    }

    return !hasErrors
  }

  html = () =>
    `<div class="container">


    <lvc-box mt="24px" textAlign="left">
      <lvc-text font-preset="titleMobileSmall">
        ${Locale.getKey('create-event-add-contributors.title')}
      </lvc-text>
    </lvc-box>

    <lvc-box mt="24px" textAlign="left">
      <lvc-text font-preset="medium">
        ${Locale.getKey('create-event-add-contributors.description')}
      </lvc-text>
    </lvc-box>

     <lvc-box mt="12px">
        <lvc-error error="${this.errors.generic}"></lvc-error>
      </lvc-box>

    <lvc-box mt="24px">
    ${
      this.errors.general
        ? `
    <lvc-box mt="12px" width="100%" justifyContent="center" display="none">
      <lvc-error error="${this.errors.general}"></lvc-error>
    </lvc-box>
  `
        : ``
    }
      <lvc-contributors-selector default-value="${encodeURIComponent(JSON.stringify(this.contributors))}"></lvc-contributors-selector>
      
    </lvc-box>

  </div>
    `

  eventListeners: EventListeners = [
    [
      'lvc-contributors-selector',
      'contributors-selector:change',
      this.handleContributorsChange.bind(this),
    ],
  ]
}
